package fr.frux.shared.data.push

import dev.zacsweers.metro.ContributesBinding
import dev.zacsweers.metro.Inject
import dev.zacsweers.metro.SingleIn
import fr.frux.core.common.di.AppScope
import fr.frux.core.common.push.PushTokenSink
import fr.frux.shared.domain.repository.NotificationRepository

/**
 * Fournit au socle ([PushTokenSink]) l'accès API qu'il ne peut pas avoir lui-même (#252 P2).
 * Passe par [NotificationRepository] et non par `NotificationsApi` : c'est le repository qui porte
 * déjà le mapping d'erreur et la journalisation, il n'y a pas de raison d'ouvrir un second chemin.
 *
 * [platform] est porté par le contrat pour les plateformes futures (iOS, M4) mais ignoré ici : le
 * repository fixe `ANDROID` en dur, seule plateforme implémentée à ce jalon (ADR 0003).
 */
@ContributesBinding(AppScope::class)
@SingleIn(AppScope::class)
@Inject
class ApiPushTokenSink(
    private val notificationRepository: NotificationRepository,
) : PushTokenSink {
    override suspend fun register(
        token: String,
        platform: String,
    ): Boolean = notificationRepository.registerPushToken(token).isSuccess

    override suspend fun revoke(token: String): Boolean = notificationRepository.revokePushToken(token).isSuccess
}
